import { render, staticRenderFns } from "./AppConfirmDialog.vue?vue&type=template&id=b8cb06e4&scoped=true&"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cb06e4",
  null
  
)

export default component.exports